import initialState from "./initialState";

export const types = {
  reset: "reset",
  SET_CONSOLES: "SET_CONSOLES",
  SET_LAYERS: "SET_LAYERS",
  SET_TIME_VALUES: "SET_TIME_VALUES",
  SET_ACTIVE_LAYER: "SET_ACTIVE_LAYER",
  SET_STATIC_ENTITIES: "SET_STATIC_ENTITIES",
  SET_STATIC_ENTITY_ID: "SET_STATIC_ENTITY_ID",
  SET_STATIC_ENTITY_FILTERS: "SET_STATIC_ENTITY_FILTERS",
  SET_REQUEST_PROGRESS: "SET_REQUEST_PROGRESS",
  SET_DATA_TABLE: "SET_DATA_TABLE",
  SET_META: "SET_META",
  SET_ACTIVE_CITY: "SET_ACTIVE_CITY",
  SET_ACTIVE_TIME: "SET_ACTIVE_TIME",
  INITIALIZE_EDITOR: "INITIALIZE_EDITOR",
  INITIALIZE_VIEWER: "INITIALIZE_VIEWER",
  INITIALIZE_CONSOLE: "INITIALIZE_CONSOLE",
  SET_APPLIED_FILTERS: "SET_APPLIED_FILTERS",
  SET_DETAILS_WIDGETS: "SET_DETAILS_WIDGETS",
  SET_DISTRIBUTION_WIDGETS: "SET_DISTRIBUTION_WIDGETS",
  SET_MODE: "SET_MODE",
};

export default {
  // mutation to reset the state with inital state
  [types.reset]: state => {
    Object.keys(initialState()).forEach(key => {
      state[key] = initialState()[key];
    });
  },

  /**
   * Sets the list of all the current dashboards
   */
  [types.SET_CONSOLES]: (state, data) => {
    state.consoles = data;
    state.consolesById = Object.keys(data);
  },

  // mutation to set the layers list in the state
  [types.SET_LAYERS]: (state, layers) => {
    state.layers = layers;
    state.layersById = Object.keys(layers);
  },

  // mutation to set the layers list in the state
  [types.SET_LAYERS]: (state, layers) => {
    state.layers = layers;
    state.layersById = Object.keys(layers);
  },

  // mutation to set the timeValues
  [types.SET_TIME_VALUES]: (state, timeValues) => {
    state.timeValues = timeValues;
  },

  // mutation to set the active layers list
  [types.SET_ACTIVE_LAYER]: (state, layerId) => {
    state.activeLayer = layerId;
  },

  // mutation to set the static entities list
  [types.SET_STATIC_ENTITIES]: (state, staticEntities) => {
    state.staticEntities = staticEntities;
  },

  // mutation to set the static entity meta
  [types.SET_STATIC_ENTITY_ID]: (state, staticEntityId) => {
    state.staticEntityId = staticEntityId;
  },

  // mutation to set the static entity filters
  [types.SET_STATIC_ENTITY_FILTERS]: (state, staticEntityFilters) => {
    state.staticEntityFilters = staticEntityFilters;
    state.staticEntityFiltersById = Object.keys(staticEntityFilters);
  },

  [types.SET_APPLIED_FILTERS]: (state, filters) => {
    state.appliedFilters = filters;
  },

  // set the details widgets
  [types.SET_DETAILS_WIDGETS]: (state, widgets) => {
    state.detailsWidgets = widgets;
  },

  [types.SET_DISTRIBUTION_WIDGETS]: (state, widgets) => {
    state.distributionWidgets = widgets;
  },

  // mutation to set the request progress
  [types.SET_REQUEST_PROGRESS]: (state, value) => {
    state.isRequestInProgress = value;
  },

  // mutation to set the dataTable data
  [types.SET_DATA_TABLE]: (state, data) => {
    state.dataTable = data;
  },

  // mutation to set the meta of the console
  [types.SET_META]: (state, meta) => {
    state.meta = meta;
  },

  // sets the active city
  [types.SET_ACTIVE_CITY]: (state, city) => {
    state.activeCity = city;
  },

  // sets the active time filters
  [types.SET_ACTIVE_TIME]: (state, time) => {
    state.activeTime = time;
  },

  // initializes the editor
  [types.INITIALIZE_CONSOLE]: (state, { mode }) => {
    state.mode = mode;
    state.isInitialized = true;
  },

  // initializes the editor
  [types.SET_MODE]: (state, { mode }) => {
    state.mode = mode;
  },

  // initializes the editor
  [types.INITIALIZE_EDITOR]: state => {
    state.mode = "EDIT";
    state.isInitialized = true;
  },

  [types.INITIALIZE_VIEWER]: state => {
    state.mode = "VIEW";
    state.isInitialized = true;
  },
};
